// Import model
import { StartContactAssignmentAskSyntheaRequest } from '../models/StartContactAssignmentAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAssignmentAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAssignmentAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAssignmentAskSyntheaRequest instance
   */
  static deserialize(json: string): StartContactAssignmentAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAssignmentAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartContactAssignmentAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAssignmentAskSyntheaRequest');
    }


    const instance: StartContactAssignmentAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAssignmentAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartContactAssignmentAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAssignmentAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartContactAssignmentAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAssignmentAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartContactAssignmentAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartContactAssignmentAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAssignmentAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
